import axios from 'axios'
import router from './router'


const instance = axios.create()
// 在实例已创建后修改默认值
instance.interceptors.request.use(function (config) {

  config.headers.token = localStorage.getItem('token')
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  if (response.data === "" && response.request.responseText != null) {
    try {
      response.data = JSON.parse(response.request.response);
    } catch (e) {
      console.log(e);
    }
  }
  if (response.data.code === 401) {
    localStorage.clear()
    router.push('/login')
  }
  return response
}, function (error) {
  return Promise.reject(error)
})

export default instance
